export default __webpack_public_path__ + "static/media/DarkBlue0004.5ea73802.png";